@if (maintance_mode) {
  <iframe [src]="maintance_mode_url" class="maintance-mode-iframe"></iframe>
}
<router-outlet></router-outlet>
<div class="lock-device">
  <h2>L'app di Futura non è ottimizzata per uno schermo così piccolo 🥺</h2>
  <p>Ti consigliamo di accedere dal computer o da un dispositivo dotato di uno schermo più grande.</p>
</div>
